import { render, staticRenderFns } from "./FolderManagement.vue?vue&type=template&id=2171eee0&scoped=true&"
import script from "./FolderManagement.vue?vue&type=script&lang=js&"
export * from "./FolderManagement.vue?vue&type=script&lang=js&"
import style0 from "./FolderManagement.vue?vue&type=style&index=0&id=2171eee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2171eee0",
  null
  
)

export default component.exports